import styled from "styled-components";
import Variables from "../../assets/styleVariables";
import * as notificationTypes from "../../constants/notificationTypes";

const typesColor= {};
typesColor[notificationTypes.REJECT_PROJECT_INVITATION_NOTIFICATION] = Variables.colors.red_50; //reject type
typesColor[notificationTypes.ACCEPT_PROJECT_INVITATION_NOTIFICATION] = Variables.colors.complementary_50;           //accept type

const shouldGoneType = notificationTypes.INVITE_PROJECT_NOTIFICATION;

export const NotifyContainer = styled.div`
  padding: 16px;
  width: 100%;
  //height: 115px;
  border-bottom: 1px solid ${Variables.colors.complementary_400};
  position: relative;
  ${props=>(props.isSeen && props.type === shouldGoneType)?'display:none;':''} //TODO with animation!!!!,
  
  .date{
    ${props => (props.isSeen && props.type!==shouldGoneType) ? 'opacity:0.5': ''};
    color: ${Variables.colors.complementary_600};
    font-size: ${Variables.font_sizes.x_small};
  }
  
  .message{
    ${props => (props.isSeen && props.type!==shouldGoneType)? 'opacity:0.5': ''};
    color: ${Variables.colors.complementary_900};
    font-size: ${Variables.font_sizes.x_medium};
    margin: 8px 0;
    line-height: 1.57;
    max-width: 280px;
    text-align: justify;
  }
  
  .footer{
    display: flex;
    width: 332px;
    justify-content: space-between;
    font-size: ${Variables.font_sizes.medium};
    
    .title{
      ${props => (props.isSeen && props.type!==shouldGoneType)? 'opacity:0.5': ''};
      padding: 5px 0;
      color: ${Variables.colors.complementary_700};
    }
    .action{
      display: none;
      flex-direction: row-reverse;
      justify-content: space-between;
      font-weight: ${Variables.font_weight.medium};
      .button1{
        cursor: pointer;
        padding: 5px 8px;
        color: ${Variables.colors.primary_vivid};
      }
      .button2{
        ${props => (props.isSeen && props.type!==shouldGoneType)? 'display:none': ''};
        cursor: pointer;
        padding: 5px 8px;
        color: ${Variables.colors.complementary_600};
      }
    }
   }
   
   &:hover{
     background-color: ${props => (typesColor[props.type]!== undefined)? typesColor[props.type] :Variables.colors.primary_50};
     .action{
        display: flex !important;
     }
   }
   
   .loading{
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    &>div{
      display: flex!important;
      justify-content: center !important;
      align-items: center !important;
      height: 100% !important;
    }
    .spinner{
      margin: 0!important;
      width: 48px !important;
      height: 48px !important;
    }
   }
   
`;